import React from "react";
import { Button, Select, Table } from "antd";
import {
  useConnectResource,
  useDeleteDevice,
  useGetDevices,
} from "../../queries/device";
import { useGetResources } from "../../queries/resource";
import { useTranslation } from "react-i18next";

const DeviceTable = () => {
  const { t } = useTranslation();
  const { data: devices } = useGetDevices();
  const { mutate: deleteDevice } = useDeleteDevice();
  const { data: resources } = useGetResources();
  const { mutate: connectResource } = useConnectResource();

  const columns = [
    {
      title: t("pages.devices.device-table.device-name"),
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend" as const,
      sorter: (a: { name: string }, b: { name: string }) =>
        a.name.localeCompare(b.name),
    },
    {
      title: t("pages.devices.device-table.device-id"),
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("pages.devices.device-table.resource"),
      dataIndex: "resource",
      key: "resource",
      width: "15rem",
      render: (
        resource: { id: string; name: string },
        device: { id: string },
      ) => (
        <Select
          defaultValue={resource.name || ""}
          style={{ width: "100%" }}
          options={[
            {
              value: "",
              label: (
                <span style={{ color: "#878787" }}>
                  {t("pages.devices.device-table.unassigned")}
                </span>
              ),
            },
            ...resources
              .filter(
                (res) =>
                  !devices.some((device) => device.resource.id === res.id),
              )
              .map((res) => ({
                value: res.id,
                label: res.name,
              })),
          ]}
          onSelect={(value) => {
            connectResource({ deviceId: device.id, resourceId: value });
          }}
        />
      ),
    },
    {
      title: t("action"),
      key: "action",
      width: "7rem",
      render: (device: { id: string }) => (
        <Button
          danger
          type="link"
          onClick={(event) => {
            event.stopPropagation();
            deleteDevice(device.id);
          }}
        >
          {t("remove")}
        </Button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={devices}
      bordered
      title={() => <strong>{t("pages.devices.device-table.title")}</strong>}
      style={{ width: "100%" }}
      rowKey={(record) => record.id}
    />
  );
};

export default DeviceTable;
